import React, { Component } from "react";
import moment from 'moment';
import { NotificationManager, NotificationContainer } from 'react-notifications';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Redirect, BrowserRouter, Route, Switch } from "react-router-dom";
import Logout from "./../../loginService/logout";
import CircularProgress  from "@material-ui/core/CircularProgress";

const backend = require('../../config.js').backend;

class Approved_Funds_Transfer_Report extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reports: {},
            staffId: sessionStorage.getItem('id_e'),
            redirectLogout: false
        }
    }

    componentDidMount() {

        this.getReports();
    }

    getReports = () => {

        var status = 'approved'
        fetch(backend + 'api/v1/fundstransferreport?status=' + status, {
            method: 'GET',
            credentials: "include",
        })
            .then(response => response.json())
            .then((data) => {

                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (data.error) {
                    if (data.error === 'no return from set approvedFiles') {
                        // console.log(data.error);
                        this.setState({ reports: {} });
                    }
                    else {
                        NotificationManager.error('ERROR:' + data.error);
                    }
                }
                else {
                    // console.log('report data', data);
                    this.setState({ reports: data });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    removeReportFromList = (filename) => {

        let { reports } = this.state;
        let r = 'reports';
        let re = reports[r];
        let report = re[filename];

        report.splice(filename, 1);
        delete re[filename];

        this.setState({ reports: reports });
    }

    deleteRequest = (filename) => {

        var { staffId } = this.state;
        // Delete it from Redis database
        var url = 'api/v1/fundstransferreport/' + staffId + `?filename=` + filename;

        fetch(backend + url, {
            method: 'DELETE',
            credentials: "include"
        })
            .then(res => res.json())
            .then(res => {

                if (res.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (res.status === 404) {
                    NotificationManager.warning(res.message, '', 10000);
                    this.removeReportFromList(filename); // Delete a report from frontend display
                }
                else if (res.status === 500) {
                    NotificationManager.error(res.message, '', 10000);
                }
                else {
                    this.removeReportFromList(filename); // Delete a report from frontend display
                }

            })
            .catch(err => console.log(err));
    }

    handleDelete = (filename) => {

        // double check with user
        var answer = window.confirm("Are you sure you want to delete this request ?");

        if (answer) {
            this.deleteRequest(filename);
        }

        if (this.state.checking && this.state.checking === filename) {
            this.setState({ renderPdf: undefined })
        }
    }

    updateReportStatusInList = (key, now, name) => {

        let { reports } = this.state;
        let report = reports[key];

        report.status = 'Approved';
        report.approvedDateTime = now;
        report.approver = name;

        this.setState({ reports: reports });
    }

    getPdfDataStream = (filename) => {
        fetch(backend + `api/v1/fundstransferreport/pdf?filename=` + filename, {
            method: 'GET',
            credentials: "include"
        })
            .then(response => response.json())
            .then((data) => {

                if (data.redirect) {
                    this.setState({ redirectLogout: true })
                    window.location.reload(false);
                }
                else if (data.error) {
                    // console.log(data.error)
                    NotificationManager.error('Getting PDF data error:' + data.error.code);
                }

                else {
                    this.setState({ renderPdf: data.data, checking: filename });
                }
            })
            .catch((err) => {
                NotificationManager.error('Getting PDF data error:' + err.toString());
            })
    }

    handleCheck = (report) => {

        this.getPdfDataStream(report.fileName);
    }

    renderReportButtons = (report) => {

        let fileName = report.fileName;
        let content;

        if (report.status === 'approved') {

            content = (
                <div className='action-group'>
                    <VisibilityIcon onClick={() => this.handleCheck(report)} />
                    <DeleteIcon onClick={() => this.handleDelete(fileName)} />
                </div>
            )
        }

        return content;
    }

    renderReports = (reports, key) => {

        var re = reports[key];
        var report = re[0];
        var filename = report.fileName;
        var period = filename.split("_");
        var date = period[0].split("to");
        var startPeriod = date[0];
        var endPeriod = date[1];
        var createdate = report.createDate;
        var approvedate = report.approveDate;

        return (

            <React.Fragment key={key}>
                <tr key={key}>
                    <td className='multiRow'>
                        {moment(startPeriod).format('MMMM') + ' ' + moment(startPeriod).format('YYYY')
                            + ' to ' + moment(endPeriod).format('MMMM') + ' ' + moment(endPeriod).format('YYYY')}
                    </td>
                    <td>{report.creatorName}<br></br>{moment(createdate, 'YYYYMMDDHHmmss').format("YYYY-MM-DD HH:mm:ss")}</td>
                    <td>{report.approverName}<br></br>{moment(approvedate, 'YYYYMMDDHHmmss').format("YYYY-MM-DD HH:mm:ss")}</td>
                    <td>{report.status}</td>
                    <td className='action'>{this.renderReportButtons(report)}</td>
                </tr>
            </React.Fragment>
        )
    }

    renderRequestList = _ => {

        var { reports } = this.state;
        // console.log('reports', reports)
        var r = 'reports';
        var re = reports[r];

        if (reports && Object.keys(reports).length) {
            return (
                <div>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Period Generated</th>
                                <th>Requestor / Date Time</th>
                                <th>Approver / Date Time</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(re).map((key, index) => (
                                this.renderReports(re, key)
                            ))}
                        </tbody>
                    </table>
                </div>
            )
        }
        else if (reports && (Object.keys(reports).length === 0)) {

            return (<h4 className='center'>No data returned</h4>)
        }
        else {

            return (
                <div style={{display:"flex", alignItems: "center", justifyContent: "center"}}>
                  <h4 className='title'>Loading... This may take a while... </h4>
                  <CircularProgress/>
                </div>)
        }
    }

    render() {

        const { redirectLogout } = this.state;

        if (redirectLogout) {
            return (
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/logout" component={Logout} />
                        <Redirect to="/logout" />
                    </Switch>
                </BrowserRouter>
            )
        }

        let requestList = this.renderRequestList();

        let content = (
            <div className="funds-transfer-approval">
                <h3 className="title">Approved Funds Transfer Report</h3>

                <div className="report-table">
                    {requestList}
                </div>

                {this.state.renderPdf ?
                    <iframe
                        title="frame"
                        height="600px"
                        src={`data:application/pdf;base64,` + this.state.renderPdf}
                    /> : null}

                <NotificationContainer />

            </div>
        )
        return (content)
    }
}

export default Approved_Funds_Transfer_Report;